import gql from 'graphql-tag';

export default gql`
    query getDriverCanBeSetInactive($carrierId: Int) {
        getDriverCanBeSetInactive(carrierId: $carrierId) {
            canBeSetInactive
        }
    }
`;
